import styled, { css } from "styled-components"
import { Link } from "gatsby"
import React from "react"
import PropTypes from "prop-types"

export const ButtonResetCSS = css`
  background-color: transparent;
  font-family: inherit;
  font-size: 100%;
  line-height: inherit;
  margin: 0;
  overflow: visible;
  text-transform: none;
  border: 0;
  padding: 0;
`
export const ButtonCSS = css`
  ${ButtonResetCSS};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: none;
  margin: 0;
  text-decoration: none;
  text-transform: ${props => (props.upperCase ? `uppercase` : `none`)};

  background-color: ${props => props.theme.colors.coral};
  font-style: normal;
  font-size: 16px;
  text-align: center;
  border-radius: 500px;
  text-rendering: optimizeLegibility;
  font-family: ${props => props.theme.fontStacks.sans};
  cursor: pointer;

  &,
  &:visited {
    color: #fff;
  }

  :hover,
  :focus {
    background-color: ${props => props.theme.colors.coralLight};
  }

  ${props => {
    switch (props.size) {
      case 2:
        return css`
          padding: 0 24px;
          height: 40px;
          font-weight: bold;
        `
      default:
        return css`
          padding: 0 15px;
          height: 32px;
        `
    }
  }}

  ${props =>
    props.buttonStyle === "outline" &&
    css`
      background-color: transparent;
      border: 2px solid ${props => props.theme.colors.coral};
      &,
      :visited {
        color: ${props => props.theme.colors.coral};
      }
      :hover {
        background-color: transparent;
      }
      :focus {
        background-color: transparent;
      }
    `};

  ${props =>
    props.buttonStyle === "grey" &&
    css`
      background-color: ${props => props.theme.colors.ash};
      &,
      &:visited {
        color: black;
      }
      :hover,
      :focus {
        background-color: ${props => props.theme.colors.lightGrey};
      }
    `};

  ${props =>
    props.buttonStyle === "darkGrey" &&
    css`
      background-color: ${props => props.theme.colors.baseGrey};
      :hover,
      :focus {
        background-color: ${props => props.theme.colors.baseGreyHover};
      }
    `};
`
const allButtonPropTypes = {
  size: PropTypes.number,
  buttonStyle: PropTypes.oneOf(["outline", "grey", "darkGrey"]),
  upperCase: PropTypes.bool,
}

export const Button = styled.button`
  ${ButtonCSS}
`
Button.propTypes = allButtonPropTypes

export const ButtonAnchor = styled.a`
  ${ButtonCSS};
  cursor: pointer;
`
ButtonAnchor.propTypes = {
  href: PropTypes.string,
  ...allButtonPropTypes,
}

export const ButtonLink = styled(
  ({ pink, quiet, light, buttonStyle, ...props }) => <Link {...props} />
)`
  ${ButtonCSS}
`
ButtonLink.propTypes = {
  to: PropTypes.string,
  ...allButtonPropTypes,
}
